export default "__VITE_ASSET__62bb5fc1__"